// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Zn-z","tupacHeader":"_n-z","tupacHeader2":"ao-z","tupacMenu":"bo-z","tupacMenu2":"co-z","tupacMain":"do-z","tupacMain2":"eo-z"};